import { Component } from 'react';

import { PRIVACY_POLICY_URL } from '../Util/PrivacyConsent';

// Ademero has one privacy policy for every product; send visitors there.
class PrivacyPolicy extends Component {
  componentDidMount() {
    window.location.replace(PRIVACY_POLICY_URL);
  }

  render() {
    return null;
  }
}

export default PrivacyPolicy;
